<div class="community-passports-container pt-4">
  <p class="page-heading cp-title my-4">Community Passports</p>
  <section class="passports-row passports-recommended">
    <p class="cp-section-title mt-4 mb-3">
      Trending
      <span class="star" [class.full]="'full'">&#9733;</span>
    </p>
    <div class="d-flex flex-row section-wrapper">
      <div class="mx-auto my-auto d-flex flex-column loader-state-wrapper" *ngIf="loaderState['TRENDING'] === 'loading'">
        <i aria-hidden="true"t class="fa fa-circle-o-notch mx-auto fa-spin fa-3x fa-fw"></i><span class="mt-3">Trending profiles coming up...</span>
      </div>
      <div class="mx-auto my-auto d-flex flex-column loader-state-wrapper" *ngIf="loaderState['TRENDING'] === 'error'">
        <i aria-hidden="true"t class="fa fa-exclamation-triangle fa-3x fa-fw"></i><span class="mt-3">Something went wrong</span>
      </div>
      <div class="d-flex flex-column justify-content-between align-items-center profile-thumbnail rounded rounded-2 {{getTrendingProfileBorder(index)}}"
        [routerLink]="['/cinejoy/passport/community', passport.userId]"
        *ngFor="let passport of communityPassports['TRENDING'];index as index">
        <img [src]="passport.userImageUrl ? passport.userImageUrl : defaultImageURL" alt="">
        <span class="star passport-star" [class.full]="'full'">&#9733;</span>
        <span class="profile-name fw-normal align-items-center mt-2 mb-0"
          placement="top" [ngbTooltip]="passport.firstName + ' ' + passport.lastName">
          {{ ((passport.firstName + ' ' + passport.lastName).length > 10)? ((passport.firstName + ' ' + passport.lastName) |
          slice : 0 : 10)+'...':(passport.firstName + ' ' + passport.lastName) }}
        </span>
      </div>
    </div>
  </section>

  <section class="passports-row passports-recommended">
    <p class="cp-section-title mt-4 mb-3">Like Minded</p>
    <div class="d-flex flex-row section-wrapper">
      <div class="mx-auto my-auto d-flex flex-column loader-state-wrapper" *ngIf="loaderState['RECOMMENDED'] === 'loading'">
        <i aria-hidden="true"t class="fa fa-circle-o-notch mx-auto fa-spin fa-3x fa-fw"></i><span class="mt-3">Finding people like you...</span>
      </div>
      <div class="mx-auto my-auto d-flex flex-column loader-state-wrapper" *ngIf="loaderState['RECOMMENDED'] === 'error'">
        <i aria-hidden="true"t class="fa fa-exclamation-triangle fa-3x fa-fw"></i><span class="mt-3">Something went wrong</span>
      </div>
      <div class="d-flex flex-column justify-content-between align-items-center profile-thumbnail rounded rounded-2 {{getRecommendedProfileBorder(index)}}"
        [routerLink]="['/cinejoy/passport/community', passport.userId]"
        *ngFor="let passport of communityPassports['RECOMMENDED'];index as index">
        <img [src]="passport.userImageUrl ? passport.userImageUrl : defaultImageURL" alt="">
        <span class="profile-name fw-normal align-items-center mt-2 mb-0"
          placement="top" [ngbTooltip]="passport.firstName + ' ' + passport.lastName">
          {{ ((passport.firstName + ' ' + passport.lastName).length > 10)? ((passport.firstName + ' ' + passport.lastName) |
          slice : 0 : 10)+'...':(passport.firstName + ' ' + passport.lastName) }}
        </span>
      </div>
    </div>
  </section>

  <section class="passports-row passports-recommended">
    <p class="cp-section-title mt-4 mb-3">New</p>
    <div class="d-flex flex-row section-wrapper">
      <div class="mx-auto my-auto d-flex flex-column loader-state-wrapper" *ngIf="loaderState['NEW'] === 'loading'">
        <i aria-hidden="true"t class="fa fa-circle-o-notch mx-auto fa-spin fa-3x fa-fw"></i><span class="mt-3">Loading the new comers...</span>
      </div>
      <div class="mx-auto my-auto d-flex flex-column loader-state-wrapper" *ngIf="loaderState['NEW'] === 'error'">
        <i aria-hidden="true"t class="fa fa-exclamation-triangle fa-3x fa-fw"></i><span class="mt-3">Something went wrong</span>
      </div>
      <div class="d-flex flex-column justify-content-between align-items-center profile-thumbnail rounded rounded-2 {{getNewProfileBorder(index)}}"
        [routerLink]="['/cinejoy/passport/community', passport.userId]"
        *ngFor="let passport of communityPassports['NEW'];index as index">
        <img [src]="passport.userImageUrl ? passport.userImageUrl : defaultImageURL" alt="">
        <span class="profile-name fw-normal align-items-center mt-2 mb-0"
          placement="top" [ngbTooltip]="passport.firstName + ' ' + passport.lastName">
          {{ ((passport.firstName + ' ' + passport.lastName).length > 10)? ((passport.firstName + ' ' + passport.lastName) |
          slice : 0 : 10)+'...':(passport.firstName + ' ' + passport.lastName) }}
        </span>
      </div>
    </div>
  </section>

  <section class="passports-row passports-recommended">
    <div class="cp-section-search mt-4 mb-2 pb-2 d-flex align-items-center justify-content-between my-4 me-4">
      <span class="cp-section-title">Discover</span>
      <div class="d-flex align-items-center justify-content-end position-relative">
        <label for="discoverSearch"></label>
        <input #discoverSearch
          type="text" max="200"
          id="discoverSearch"
          placeholder="Search"
          class="discover-search"
          (blur)="resetSearchOnBlur(discoverSearch.value)"
          (keyup)="getSearchResultEnter($event, discoverSearch.value)" >
        <button type="button" (click)="getSearchResult(discoverSearch.value)">
          <i class="fa fa-search"></i>
        </button>
      </div>
    </div>
    <div class="d-flex flex-row section-wrapper">
      <div class="mx-auto my-auto d-flex flex-column loader-state-wrapper" *ngIf="loaderState['DISCOVER'] === 'loading'">
        <i aria-hidden="true"t class="fa fa-circle-o-notch mx-auto fa-spin fa-3x fa-fw"></i><span class="mt-3">Discovering Profiles for you...</span>
      </div>
      <div class="mx-auto my-auto d-flex flex-column loader-state-wrapper" *ngIf="loaderState['DISCOVER'] === 'error'">
        <i aria-hidden="true"t class="fa fa-exclamation-triangle fa-3x fa-fw"></i><span class="mt-3">Something went wrong</span>
      </div>
      <div class="d-flex flex-column justify-content-between align-items-center profile-thumbnail rounded rounded-2 {{getDiscoverProfileBorder(index)}}"
        [routerLink]="['/cinejoy/passport/community', passport.userId]"
        *ngFor="let passport of communityPassports['DISCOVER'];index as index">
        <img [src]="passport.userImageUrl ? passport.userImageUrl : defaultImageURL" alt="">
        <span class="profile-name fw-normal align-items-center mt-2 mb-0"
          placement="top" [ngbTooltip]="passport.firstName + ' ' + passport.lastName">
          {{ ((passport.firstName + ' ' + passport.lastName).length > 10)? ((passport.firstName + ' ' + passport.lastName) |
          slice : 0 : 10)+'...':(passport.firstName + ' ' + passport.lastName) }}
        </span>
      </div>
      <div *ngIf="noMatchFound" class="profile-thumbnail justify-content-center d-flex mx-auto">
        <p class="no-result align-items-center">No Results Found</p>
      </div>
    </div>
  </section>
</div>
